export default {
	common: {
		retry: 'Réessayer',
		retry_access: 'Réessayer l\'accès',
		see_more: 'Voir plus',
		system_default_device: 'Par défaut du système',
		problem_occurred: 'Un problème est survenu lors de la tentative de connexion à la consultation vidéo. Vous serez redirigé vers la salle d\'attente.',
		insurance: 'Assurance'
	},
	datetime: {
		locale: 'fr',
		datetime_format: 'DD/MM/YYYY · HH:mm',
	},
	config: {
		microphone: 'Microphone',
		external_headphones: 'Écouteurs externes',
		camera: 'Caméra',
		how_to_permissions: 'Comment activer les permissions?',
		mic_and_vid_not_granted: 'Votre microphone et votre caméra sont désactivés.',
		permissions_text: 'Pour que les autres participants puissent vous entendre et vous voir, le navigateur que vous utilisez pour rejoindre la consultation vidéo demandera <strong>l\'accès à votre microphone et à votre caméra</strong>. <p>Enfin, vous devez terminer <strong>la configuration des préférences système</strong> pour continuer.</p>',
	},
	waiting_room: {
		next_videoconsultation: 'Prochaine consultation vidéo',
		videoconsultation: 'Consultation vidéo',
		title: 'Vous êtes sur le point de rejoindre une consultation vidéo',
		info: 'Information',
		access: 'Accéder',
		professional_not_available: {
			title: 'EN ATTENTE DU PROFESSIONNEL',
			message: 'Votre médecin ne s’est pas encore connecté. Des petits retards peuvent survenir. Merci de votre patience.',
		},
		professional_no_show: {
			title: 'LE PROFESSIONNEL NE S\'EST PAS PRÉSENTÉ',
			message: 'Le professionnel a rencontré un imprévu et ne sera probablement pas en mesure de se joindre à la consultation. Nous vous prions de bien vouloir nous excuser pour ce désagrément et vous recommandons de prendre un nouveau rendez-vous.'
		},
		capabilities_ko: {
			title: 'CLIENT NON SUPPORTE',
			message: 'Votre navigateur ou appareil n\'est pas compatible avec la vidéoconsultation. Veuillez mettre à jour votre navigateur ou changer votre appareil de connexion.'
		},
	},
	participant_info: {
		professional: 'Professionnel',
		patient: 'Patient',
		subject: 'Motif',
		subject_long: 'Motif de la consultation',
		speciality: 'Spécialité',
		datetime: 'Date et heure',
		duration: 'Durée estimée',
		copy_link: 'Copier le lien',
	},
	tools: {
		chat: 'Chat privé',
	},
	chat: {
		empty_title: 'Voulez-vous démarrer le chat privé?',
		empty_description:
			'Seuls les participants à cette consultation vidéo auront accès aux messages envoyés.',
		type: 'Saisissez votre message...',
	},
	hang_up: {
		title: 'Terminer la consultation vidéo',
		finish: 'Terminer',
		suspend: 'Mettre en attente',
		warning:
			'Afin de qualifier cette consultation vidéo de réussie, il est nécessaire qu\'elle dure au moins trois minutes.',
		message: 'Ce lien d\'accès est à usage unique. Si vous <strong>terminez</strong> cette consultation, vous ne pourrez pas y accéder de nouveau, même pendant le créneau prévu.',
	},
	too_early: {
		title: 'ACCÈS À LA VIDÉOCONSULTATION',
		vc_time: 'Heure de la consultation vidéo',
		waiting_time: 'Délai d\'attente',
		message: 'Il est encore trop tôt pour rejoindre. Veuillez réessayer dans quelques minutes: votre médecin peut arriver en avance et vous donner accès avant l’heure prévue. <br/> (sera combiné avec l’heure, ex. “Lundi 15:20”)',
		professional_available:
			'Votre médecin est disponible, vous pouvez maintenant accéder à votre vidéoconsultation.',
	},
	permissions: {
		title: 'Activez caméra et micro',
		content: 'Pour démarrer votre téléconsultation, nous avons besoin d’accéder à votre caméra et micro.',
		request_permissions: 'Autoriser l’accès',
	},
	vc: {
		finish_title: 'FIN DE LA CONSULTATION VIDÉO',
		finish_content:
			'La vidéoconsultation s’est terminée avec succès.Merci d’utiliser notre plateforme!',
	},
	feedback: {
		title: 'COMMENT ÉVALUERIEZ-VOUS VOTRE CONSULTATION VIDÉO?',
		success_by_video: 'Réussie par vidéo',
		success_by_phone: 'Réussie par téléphone',
		unsuccess: 'Sans succès',
		reason: 'Indiquez la raison:',
		patient_not_shown_up: 'Le patient ne s\'est pas présenté',
		patient_could_not_connect: 'Le patient n\'a pas pu se connecter',
		other: 'Autre',
		fail_message: 'Le feedback n\'a pas pu être envoyé. Veuillez réessayer.',
		already_registered_message: 'Cette téléconsultation a déjà été évaluée. Il n\'est pas possible de l\'évaluer à nouveau.',
	},
	meet_actions: {
		copy_link: 'Copier le lien',
		share_screen: 'Partager l\'écran',
		stop_share_screen: 'Arrêter le partage',
	},
	alerts: {
		copied_link: 'Lien d\'accès à la consultation vidéo copié.',
		participant_disabled_cam: 'a désactivé sa caméra.',
		participant_disabled_mic: 'a désactivé son microphone.',
		sharing_screen: 'Vous partagez votre écran',
		presentation: 'Présentation de',
	},
	errors: {
		title: 'Informations sur votre téléconsultation',
		invalid_code:
			'Impossible d\'accéder à la vidéoconsultation. Cela peut être dû à un lien invalide, inexistant ou à l\'heure prévue qui n\'est pas encore arrivée.',
		title_too_early: 'Salle d\'attente',
		too_early: 'Vous arrivez en avance ! Réessayez dans quelques minutes.',
		title_finished_meet: 'Consultation vidéo indisponible',
		finished_meet: 'L\'heure de votre consultation vidéo s\'est écoulée. Ce lien a expiré.',
		title_too_late: 'Consultation vidéo terminée',
		too_late: 'Cette consultation vidéo est déjà terminée.',
		refresh_meet_failed: 'Une erreur s\'est produite lors du chargement des données de la consultation vidéo. Veuillez réessayer.',
		devices_in_use_title: 'Appareils en cours d\'utilisation',
		devices_in_use_description: 'Vous ne pouvez pas accéder à la consultation vidéo en raison d\'un problème d\'accès avec votre microphone et votre caméra. Veuillez vérifier qu\'aucune autre application ne les utilise et accordez les autorisations lorsque votre navigateur vous y invite.',
		devices_not_found: 'Appareils introuvables',
		devices_denied: 'Autorisations des appareils refusées',
		devices_error: 'Erreur lors de l\'utilisation du microphone/caméra'
	},
};
